import React, { useEffect, useState } from "react";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { subscribe } from "../lib/api";

export const SubscribeForm = ({ sourceSlug = "" }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (status !== "done") return;
    const t = setTimeout(() => {
      setStatus("idle");
      setEmail("");
      setMessage("");
    }, 3500);
    return () => clearTimeout(t);
  }, [status]);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    try {
      const res = await subscribe(email.trim(), sourceSlug);
      setStatus("done");
      if (res.lead_magnet_delivered) {
        setMessage("You're in — the download is on its way to your inbox.");
      } else if (res.already_subscribed) {
        setMessage("You're already on the list — thanks!");
      } else {
        setMessage("You're in. Look for the next dispatch.");
      }
    } catch (err) {
      setStatus("error");
      const detail = err?.response?.data?.detail;
      setMessage(
        typeof detail === "string"
          ? detail
          : "Something went wrong. Try again.",
      );
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid="subscribe-form"
      className="flex items-stretch border border-black/90 bg-white max-w-md"
    >
      <input
        data-testid="subscribe-email"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        disabled={status === "loading" || status === "done"}
        className="flex-1 px-3 py-2.5 text-[13px] font-medium bg-transparent outline-none placeholder:text-zinc-400 disabled:opacity-60"
      />
      <button
        data-testid="subscribe-submit"
        type="submit"
        disabled={status === "loading" || status === "done"}
        className="font-display text-[10px] font-bold uppercase tracking-[0.2em] px-4 bg-[#0A0A0A] text-white hover:bg-[#002FA7] transition-colors flex items-center gap-2 disabled:opacity-60"
      >
        {status === "done" ? (
          <>
            Subscribed <CheckCircle2 size={14} strokeWidth={2.5} />
          </>
        ) : status === "loading" ? (
          "Sending…"
        ) : (
          <>
            Subscribe <ArrowRight size={14} strokeWidth={2.5} />
          </>
        )}
      </button>
      {message && (
        <p
          data-testid="subscribe-message"
          className={`absolute -mb-7 mt-12 text-[10px] font-medium tracking-wide ${
            status === "error" ? "text-[#FF2A00]" : "text-zinc-500"
          }`}
        >
          {message}
        </p>
      )}
    </form>
  );
};

export default SubscribeForm;
